import React from 'react'
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap'
import { formatDate, formatMoney } from 'helpers/helpers';

function Detail({ modal, setModal, item = {}, showTotal = true }) {
    const { t } = useTranslation();

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)} dialogClassName="second">
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('request_details')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('view_request_details')}
                </div>

                <div className="d-flex flex-column gap-5 w-50">
                    <div className="d-between">
                        <div className="text-second">{t('warehouse')}</div>
                        <div>{item.warehouse_name}</div>
                    </div>
                    <div className="d-between">
                        <div className="text-second">{t('status')}</div>
                        <div className={`alert alert-${item.status} m-0 py-1 px-2`}>
                            {t(item.status)}
                        </div>
                    </div>
                    <div className="d-between">
                        <div className="text-second">{t('priority')}</div>
                        <div className={`priority priority-${item.priority}`}>
                            {t(item.priority)}
                        </div>
                    </div>
                    <div className="d-between">
                        <div className="text-second">{t('created_at')}</div>
                        <div>{formatDate(item.created_at)}</div>
                    </div>
                    {showTotal &&
                        <div className="d-between">
                            <div className="text-second">{t('amount')}</div>
                            <div className="fw-bold">
                                {formatMoney(item.total_cost)}
                            </div>
                        </div>
                    }
                    {item.comment && (
                        <div className="d-between">
                            <div className="text-second">{t('comment')}</div>
                            <div className="small">{item.comment}</div>
                        </div>
                    )}
                </div>

                <hr />

                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th style={{ width: '10%' }}>{t('code')}</th>
                                <th style={{ width: '30%' }}>{t('raw_material')}</th>
                                <th style={{ width: '20%' }}>{t('quantity')}</th>
                                {showTotal &&
                                    <th style={{ width: '20%' }}>{t('unit_price')}</th>
                                }
                                <th style={{ width: '20%' }}>{t('unit_short')}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {item.items?.map((subItem, index) => (
                                <tr key={index}>
                                    <td className="text-second">
                                        {subItem.raw_material_code}
                                    </td>
                                    <td>
                                        <div className="fw-bold">{subItem.raw_material_name}</div>
                                    </td>
                                    <td>{formatMoney(subItem.quantity)}</td>
                                    {showTotal &&
                                        <td>{formatMoney(subItem.unit_price)}</td>
                                    }
                                    <td>{subItem.unit_short_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default Detail